module.exports = __webpack_public_path__ + "static/noticias-20-cdc99e992a16655e490f8f7f6b8cebc0.jpg";